import { useEffect, useState } from "react"
import useHomepageList from "./useHomepageList"
import { useNavigate, useLocation } from "react-router-dom"
import { BsFillTrashFill, BsPencilSquare } from "react-icons/bs"
import DeleteModal from "../../../components/modal/DeleteModal"
import ActionButtonGradient from "../../../components/button/ActionButtonGradient"

const HomepageList = () => {
    const {
        homepages,
        getHomepageList,
        deleteAnnouncement,
    } = useHomepageList()

    const navigate = useNavigate()
    const location = useLocation()
    const [imageUpdateTime, setImageUpdateTime] = useState(Date.now())

    useEffect(() => {
        getHomepageList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Refresh data when navigating back with refresh flag
    useEffect(() => {
        if (location.state?.refresh) {
            getHomepageList()
            // Update timestamp to bust image cache
            setImageUpdateTime(Date.now())
            // Clear the state to prevent refetch on future navigation
            navigate(location.pathname, { replace: true, state: {} })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state])

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [deleteID, setDeleteID] = useState();
    const [userName, setName] = useState();

    return(
        <div className="container-fluid d-flex justify-content-center">
            <div style={{ width: '100%', maxWidth: '1200px' }}>
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h3 style={{ margin: 0, fontWeight: 600, color: '#1a1a1a' }}>Announcement Management</h3>
                    <ActionButtonGradient
                        onClick={() => navigate("/home/form")}
                        variant="success"
                        children={"Create Announcement"}
                    />
                </div>
            
            <div style={{ display: 'grid', gap: '16px' }}>
                {
                    homepages.map((data) => (
                        <div 
                            key={data.ID}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '20px',
                                backgroundColor: '#ffffff',
                                borderRadius: '12px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                border: '1px solid #f0f0f0',
                                transition: 'border-color 0.2s ease',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = '#02B4CC';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = '#f0f0f0';
                            }}
                        >
                            <div className="d-flex align-items-center gap-3">
                                <div style={{
                                    width: '120px',
                                    height: '80px',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    backgroundColor: '#f8f9fa',
                                    flexShrink: 0
                                }}>
                                    <img 
                                        src={`${data.FileLink}?t=${imageUpdateTime}`} 
                                        alt={data.FileName} 
                                        style={{ 
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                </div>

                                <div>
                                    <h5 style={{ 
                                        margin: 0, 
                                        marginBottom: '8px',
                                        fontWeight: 600,
                                        color: '#1a1a1a',
                                        fontSize: '18px'
                                    }}>
                                        {data.Title}
                                    </h5>
                                    <div style={{
                                        display: 'inline-block',
                                        padding: '4px 12px',
                                        borderRadius: '20px',
                                        fontSize: '13px',
                                        fontWeight: 500,
                                        backgroundColor: data.Active ? '#e6f7f7' : '#f5f5f5',
                                        color: data.Active ? '#02B4CC' : '#666666'
                                    }}>
                                        {data.Active ? "● Active" : "○ Inactive"}
                                    </div>
                                </div>
                            </div>
                            
                            <div className="d-flex gap-2">
                                <button 
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigate(`/home/form/${data.ID}`);
                                    }}    
                                    title="Edit announcement"
                                    style={{
                                        padding: '8px 12px',
                                        borderRadius: '5px',
                                        border: '1px solid #02B4CC',
                                        backgroundColor: 'transparent',
                                        color: '#02B4CC',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#02B4CC';
                                        e.currentTarget.style.color = 'white';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.color = '#02B4CC';
                                    }}
                                >
                                    <BsPencilSquare size={14}/>
                                    Edit
                                </button>
                                <button 
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleShow();
                                        setDeleteID(data.ID);
                                        setName(data.Title);
                                    }}   
                                    title="Delete announcement"
                                    style={{
                                        padding: '8px 12px',
                                        borderRadius: '5px',
                                        border: '1px solid #dc3545',
                                        backgroundColor: 'transparent',
                                        color: '#dc3545',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#dc3545';
                                        e.currentTarget.style.color = 'white';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.color = '#dc3545';
                                    }}
                                >
                                    <BsFillTrashFill size={14}/>
                                    Delete
                                </button>
                            </div>
                        </div>
                    ))
                }
            </div>

            <DeleteModal show={show} handleClose={handleClose} handleOk={() => {
                handleClose()
                deleteAnnouncement(deleteID).then(() => {
                    // Update timestamp to bust image cache after delete
                    setImageUpdateTime(Date.now())
                })
            }} title={userName}/>
            </div>
        </div>
    )
}

export default HomepageList